export class EmployeeSecurityQuestionsModel {
    userID: number;
    SecurityQuestion1: string;
    SecurityQuestion2: string;
    SecurityQuestion3: string;
    SecurityAnswer1: string;
    SecurityAnswer2: string;
    SecurityAnswer3: string;
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/models/securityquestions.model.ts